import React, { useState, useEffect, useCallback, useRef } from "react";
import "./../../../../assets/css/purchase/form.css";

import InitialDataFormLayout from "../components/InitialDataFormLayout";
import {
  labelStyle,
  inputStyle,
  sectionHeaderStyle,
  sectionIconStyle,
  sectionTitleStyle,
} from "../components/formStyles";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
  getDataWithComp,
} from "../../../../utils/SamuiUtils";
import api from "../../../../utils/axios";
import SearchableSelect from "../../../components/SearchableSelect";

const buildDefaultForm = () => ({
  AP_Id: "",
  Comp_Id: window.localStorage.getItem("company") || "",
  AP_Code: "",
  AP_Name: "",
  AP_Type: 1,
  AP_ShortName: "",
  AP_TaxNo: "",
  AP_Add1: "",
  AP_Add2: "",
  AP_Add3: "",
  AP_Province: "",
  AP_Zipcode: "",
  AP_Contact: "",
  AP_Tel: "",
  AP_Status: "Y",
  AP_Credit: 0,
  AP_Vat: 1,
  AP_Discount: 0,
  AP_Branch: "",
  AP_BT_Name: "",
  Bank_Id: null,
  Bank_Acc_No: "",
  Bank_Acc_Name: "",
});

const CreditorForm = ({ callInitialize, mode, name, formData, setFormData, selectedData, masterList = [] }) => {
  const [initialFormData, setInitialFormData] = useState(buildDefaultForm());
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false);

  useEffect(() => {
    if (mode === "I") {
      const defaults = buildDefaultForm();
      setFormData(defaults);
      setInitialFormData(defaults);
    } else if (mode === "U" && selectedData) {
      const editData = {
        AP_Id: selectedData.AP_Id,
        Comp_Id: selectedData.Comp_Id || window.localStorage.getItem("company") || "",
        AP_Code: selectedData.AP_Code || "",
        AP_Name: selectedData.AP_Name || "",
        AP_Type: selectedData.AP_Type || 1,
        AP_ShortName: selectedData.AP_ShortName || "",
        AP_TaxNo: selectedData.AP_TaxNo || "",
        AP_Add1: selectedData.AP_Add1 || "",
        AP_Add2: selectedData.AP_Add2 || "",
        AP_Add3: selectedData.AP_Add3 || "",
        AP_Province: selectedData.AP_Province || "",
        AP_Zipcode: selectedData.AP_Zipcode || "",
        AP_Contact: selectedData.AP_Contact || "",
        AP_Tel: selectedData.AP_Tel || "",
        AP_Status: selectedData.AP_Status || "Y",
        AP_Credit: selectedData.AP_Credit || 0,
        AP_Vat: selectedData.AP_Vat || 1,
        AP_Discount: selectedData.AP_Discount || 0,
        AP_Branch: selectedData.AP_Branch || "",
        AP_BT_Name: selectedData.AP_BT_Name || "",
        Bank_Id: selectedData.Bank_Id || null,
        Bank_Acc_No: selectedData.Bank_Acc_No || "",
        Bank_Acc_Name: selectedData.Bank_Acc_Name || "",
      };

      setFormData(editData);
      setInitialFormData(editData);
    }
    api.get("/provinces").then((r) => setProvinces(r.data.data || []));
  }, [mode, selectedData, setFormData]);

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subdistricts, setSubdistricts] = useState([]);
  const [selProvinceId, setSelProvinceId] = useState("");
  const [selDistrictId, setSelDistrictId] = useState("");
  const [selSubdistrictId, setSelSubdistrictId] = useState("");

  const [bankList, setBankList] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [bankForm, setBankForm] = useState({ Bank_Id: null, Bank_Account: "", Bank_Name_TH: "", Bank_Type: "SA" });
  const [bankEditing, setBankEditing] = useState(false);
  const isCreditor =
    formData?.AP_Type === "AP" ||
    String(formData?.AP_Type) === "1" ||
    selectedData?.AP_Type === "AP" ||
    String(selectedData?.AP_Type) === "1";

  const handleBack = () => {
    callInitialize();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
   
    const formatPhone = (v) => {
      const digits = String(v).replace(/\D/g, "").slice(0, 10); // allow up to 10 digits
      if (digits.length <= 3) return digits;
      return digits.slice(0, 3) + '-' + digits.slice(3);
    };

    const formatTaxId = (v) => {
      let d = String(v).replace(/\D/g, "").slice(0, 13);
      const parts = [];
      const pattern = [1, 4, 5, 2, 1];
      let pos = 0;
      for (let len of pattern) {
        if (pos >= d.length) break;
        const take = Math.min(len, d.length - pos);
        parts.push(d.substr(pos, take));
        pos += take;
      }
      return parts.join('-');
    };

    if (name === 'AP_Tel') {
      const formatted = formatPhone(value);
      setFormData((prev) => ({ ...prev, [name]: formatted }));
      return;
    }

    if (name === 'AP_TaxNo') {
      const formatted = formatTaxId(value);
      setFormData((prev) => ({ ...prev, [name]: formatted }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInsert = useCallback(async () => {
    try {
      const { AP_Id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);
      await insertData("Tb_Set_AP", fields, values);
      return true;
    } catch (error) {
      console.error("Error inserting AP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
      return false;
    }
  }, [formData]);

  const handleUpdate = useCallback(async () => {
    try {
      const where = { AP_Id: formData.AP_Id };
      const { AP_Id, ...values } = formData;
      const res = await updateData("Tb_Set_AP", values, where);
      if (res) {
        return true;
      }
      getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้");
      return false;
    } catch (error) {
      console.error("Error updating AP:", error);
      getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว");
      return false;
    }
  }, [formData]);

  const handleDelete = async () => {
    if (!selectedData?.AP_Id) {
      getAlert("WARNING", "ไม่พบข้อมูลที่ต้องการลบ");
      return;
    }

    getAlert("C_DIALOG", "ยืนยันการลบข้อมูล (จะเปลี่ยนสถานะเป็นไม่ใช้งาน)", async (isConfirm) => {
      if (!isConfirm) return;
      try {
        const where = { AP_Id: selectedData.AP_Id };
        const values = { AP_Status: "N" };
        await updateData("Tb_Set_AP", values, where);
        await callInitialize();
      } catch (error) {
        getAlert("FAILED", "ไม่สามารถเปลี่ยนสถานะได้ กรุณาลองใหม่อีกครั้ง");
      }
    });
  };

  const handleReset = () => {
    setFormData(initialFormData);
    if (mode === "U") {
      setDistricts([]);
      setSubdistricts([]);

      if (initialFormData.AP_Province && provinces && provinces.length) {
        const p = provinces.find((x) => x.NameInThai === initialFormData.AP_Province);
        if (p) {
          setSelProvinceId(p.ProvinceId);
          api.get(`/districts/${p.ProvinceId}`).then((r) => {
            const ds = r.data.data || [];
            setDistricts(ds);
            if (initialFormData.AP_Add3) {
              const d = ds.find((x) => x.NameInThai === initialFormData.AP_Add3);
              if (d) {
                setSelDistrictId(d.DistrictId);
                api.get(`/subdistricts/${d.DistrictId}`).then((rs) => {
                  const ss = rs.data.data || [];
                  setSubdistricts(ss);
                  if (initialFormData.AP_Add2) {
                    const s = ss.find((x) => x.NameInThai === initialFormData.AP_Add2);
                    if (s) setSelSubdistrictId(s.SubdistrictId);
                  }
                });
              }
            }
          });
        } else {
          setSelProvinceId("");
          setSelDistrictId("");
          setSelSubdistrictId("");
        }
      } else {
        setSelProvinceId("");
        setSelDistrictId("");
        setSelSubdistrictId("");
      }
    } else {
      setSelProvinceId("");
      setSelDistrictId("");
      setSelSubdistrictId("");
      setDistricts([]);
      setSubdistricts([]);
    }
  };

  useEffect(() => {
    if (!provinces.length) return;
    if (formData.AP_Province) {
      const p = provinces.find((x) => x.NameInThai === formData.AP_Province);
      if (p) {
        setSelProvinceId(p.ProvinceId);
        api.get(`/districts/${p.ProvinceId}`).then((r) => setDistricts(r.data.data || []));
      }
    }
  }, [provinces]);

  useEffect(() => {
    const loadBanks = async () => {
      if (mode === "U" && selectedData?.AP_Id) {
        setBankLoading(true);
        try {
          const cond = `AND Bank_Status = 'Y' AND APAR_Type = 'AP' AND APAR_Id = ${selectedData.AP_Id} ORDER BY Bank_Id ASC`;
          const b = await getDataWithComp("Tb_Set_Bank", cond);
          if (Array.isArray(b)) setBankList(b);
          else setBankList([]);
        } catch (err) {
          console.error("โหลดบัญชีธนาคารไม่สำเร็จ", err);
          setBankList([]);
        } finally {
          setBankLoading(false);
        }
      } else {
        setBankList([]);
      }
    };
    loadBanks();
  }, [mode, selectedData]);

  useEffect(() => {
    if (!districts.length) return;
    if (formData.AP_Add3) {
      const d = districts.find((x) => x.NameInThai === formData.AP_Add3);
      if (d) {
        setSelDistrictId(d.DistrictId);
        api.get(`/subdistricts/${d.DistrictId}`).then((r) => setSubdistricts(r.data.data || []));
      }
    }
  }, [districts]);

  useEffect(() => {
    if (!subdistricts.length) return;
    if (formData.AP_Add2) {
      const s = subdistricts.find((x) => x.NameInThai === formData.AP_Add2);
      if (s) {
        setSelSubdistrictId(s.SubdistrictId);
        setFormData((prev) => ({ ...prev, AP_Zipcode: s.ZipCode || prev.AP_Zipcode }));
      }
    }
  }, [subdistricts]);

  const handleSubmit = async () => {
    if (isSavingRef.current) return;
    if (!formData.AP_Code) {
      getAlert("WARNING", "กรุณากรอกรหัสผู้ขาย");
      return;
    }
    if (!formData.AP_Name) {
      getAlert("WARNING", "กรุณากรอกชื่อผู้ขาย");
      return;
    }

    // ตรวจสอบเลขประจำตัวผู้เสียภาษี: ถ้ามี ให้ยอมรับเฉพาะตัวเลขและ - และจำนวนตัวเลขต้องเท่ากับ 13
    if (formData.AP_TaxNo) {
      const digitsOnly = String(formData.AP_TaxNo).replace(/[^0-9]/g, "");
      if (digitsOnly.length !== 13) {
        getAlert("WARNING", "เลขประจำตัวผู้เสียภาษีต้องมีตัวเลข 13 หลัก (ไม่รวมยัติภังค์)");
        return;
      }
    }

    if (formData.AP_Code) {
      const code = String(formData.AP_Code).trim().toLowerCase();
      const duplicate = masterList.some((m) => {
        if (!m) return false;
        const mCode = (m.AP_Code || "").toString().trim().toLowerCase();
        if (!mCode) return false;
        if (mode === 'U' && (m.AP_Id === formData.AP_Id || String(m.AP_Id) === String(formData.AP_Id))) return false;
        return mCode === code;
      });
      if (duplicate) {
        getAlert("WARNING", "รหัสผู้ขายซ้ำ กรุณากรอกรหัสใหม่");
        return;
      }
    }

    isSavingRef.current = true;
    setIsSaving(true);
    try {
      const success = mode === "I" ? await handleInsert() : await handleUpdate();
      if (!success) return;
      await callInitialize();
      const defaults = buildDefaultForm();
      setFormData(defaults);
      setInitialFormData(defaults);
    } finally {
      isSavingRef.current = false;
      setIsSaving(false);
    }
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
   
    if (name === 'Bank_Account') {
      const digits = String(value).replace(/\D/g, '').slice(0, 10);
      let formatted = digits;
      if (digits.length > 3 && digits.length <= 6) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      } else if (digits.length > 6) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
      setBankForm((prev) => ({ ...prev, Bank_Account: formatted }));
      return;
    }

    setBankForm((prev) => ({ ...prev, [name]: value }));
  };

  const startAddBank = () => {
    setBankForm({ Bank_Id: null, Bank_Account: "", Bank_Name_TH: "", Bank_Type: "SA" });
    setBankEditing(true);
  };

  const startEditBank = (bank) => {
    setBankForm({ Bank_Id: bank.Bank_Id, Bank_Account: bank.Bank_Account || "", Bank_Name_TH: bank.Bank_Name_TH || "", Bank_Type: bank.Bank_Type || "SA" });
    setBankEditing(true);
  };

  const cancelBankEdit = () => {
    setBankForm({ Bank_Id: null, Bank_Account: "", Bank_Name_TH: "", Bank_Type: "SA" });
    setBankEditing(false);
  };

  const saveBank = async () => {
    try {
      if (!selectedData?.AP_Id) {
        getAlert("WARNING", "ไม่พบรหัสผู้ขาย กรุณบันทึกผู้ขายก่อน");
        return;
      }

      if (!bankForm.Bank_Account || !bankForm.Bank_Name_TH) {
        getAlert("WARNING", "กรุณาระบุเลขที่บัญชี และ ชื่อบัญชี");
        return;
      }

      const digits = String(bankForm.Bank_Account || "").replace(/\D/g, "");
      if (digits.length !== 10) {
        getAlert("WARNING", "รูปแบบเลขที่บัญชีต้องเป็น xxx-xxx-xxxx (10 ตัวเลข)");
        return;
      }
      const formattedAcc = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;

      const payload = {
        Bank_Account: formattedAcc,
        Bank_Name_TH: bankForm.Bank_Name_TH,
        Bank_Type: bankForm.Bank_Type || "SA",
        APAR_Type: "AP",
        APAR_Id: selectedData.AP_Id,
        Comp_Id: window.localStorage.getItem("company") || "",
        Bank_Status: "Y",
      };

      if (bankForm.Bank_Id) {
        const where = { Bank_Id: bankForm.Bank_Id };
        const { Bank_Id, ...values } = payload;
        await updateData("Tb_Set_Bank", values, where);
      } else {
        const fields = Object.keys(payload).join(", ");
        const values = Object.values(payload);
        await insertData("Tb_Set_Bank", fields, values);
      }

      const cond = `AND Bank_Status = 'Y' AND APAR_Type = 'AP' AND APAR_Id = ${selectedData.AP_Id} ORDER BY Bank_Id ASC`;
      const b = await getDataWithComp("Tb_Set_Bank", cond);
      setBankList(Array.isArray(b) ? b : []);
      setBankForm((prev) => ({ ...prev, Bank_Account: formattedAcc }));
      cancelBankEdit();
    } catch (err) {
      console.error(err);
      getAlert("FAILED", "ไม่สามารถบันทึกบัญชีธนาคารได้ กรุณาลองใหม่");
    }
  };

  const removeBank = (bankId) => {
    getAlert("C_DIALOG", "ยืนยันการลบบัญชีธนาคาร?", async (ok) => {
      if (!ok) return;
      try {
        await deleteData("Tb_Set_Bank", `WHERE Bank_Id = ${bankId}`);
        setBankList((prev) => prev.filter((b) => b.Bank_Id !== bankId));
      } catch (err) {
        console.error(err);
        getAlert("FAILED", "ไม่สามารถลบบัญชีธนาคารได้");
      }
    });
  };

  return (
    <>
      <InitialDataFormLayout
        name={name}
        entityPath="/creditor"
        mode={mode}
        onSubmit={handleSubmit}
        isSubmittingDisabled={isSaving}
        onBack={handleBack}
        onReset={handleReset}
        onDelete={mode === "U" ? handleDelete : undefined}
        callInitialize={callInitialize}
      >
        <div className="mb-5">
          <div style={sectionHeaderStyle}>
            <i className="fas fa-building" style={sectionIconStyle}></i>
            <h5 style={sectionTitleStyle}>ข้อมูลผู้ขาย</h5>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>รหัสผู้ขาย <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="AP_Code" className="form-control" value={formData.AP_Code || ""} onChange={handleChange} style={inputStyle} />
            </div>
            <div className="col-lg-8 col-md-6">
              <label style={labelStyle}>ชื่อผู้ขาย <span style={{ color: '#dc2626' }}>*</span></label>
              <input type="text" name="AP_Name" className="form-control" value={formData.AP_Name || ""} onChange={handleChange} style={inputStyle} />
            </div>
            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>เลขประจำตัวผู้เสียภาษี</label>
              <input type="text" name="AP_TaxNo" className="form-control" value={formData.AP_TaxNo || ""} onChange={handleChange} maxLength={17} style={inputStyle} />
            </div>
            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>โทรศัพท์</label>
              <input type="text" name="AP_Tel" className="form-control" value={formData.AP_Tel || ""} onChange={handleChange} maxLength={11} style={inputStyle} />
            </div>
            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>สถานะ</label>
              <select name="AP_Status" className="form-select" value={formData.AP_Status || "Y"} onChange={handleChange} style={inputStyle}>
                <option value="Y">ใช้งาน</option>
                <option value="N">ไม่ใช้งาน</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <div style={sectionHeaderStyle}>
            <i className="fas fa-map-marker-alt" style={sectionIconStyle}></i>
            <h5 style={sectionTitleStyle}>ที่อยู่</h5>
          </div>
          <div className="row g-4">
            <div className="col-12">
              <label style={labelStyle}>ที่อยู่</label>
              <input type="text" name="AP_Add1" className="form-control" value={formData.AP_Add1 || ""} onChange={handleChange} style={inputStyle} />
            </div>

            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>จังหวัด</label>
              <SearchableSelect
                value={selProvinceId}
                options={provinces.map((p) => ({ value: p.ProvinceId, label: p.NameInThai }))}
                placeholder="เลือกจังหวัด"
                searchPlaceholder="ค้นหาจังหวัด..."
                onChange={async (v, opt) => {
                  setSelProvinceId(v);
                  setFormData((prev) => ({ ...prev, AP_Province: opt?.label || "", AP_Add3: "", AP_Add2: "", AP_Zipcode: "" }));
                  setDistricts([]);
                  setSubdistricts([]);
                  setSelDistrictId("");
                  setSelSubdistrictId("");
                  if (v) {
                    const res = await api.get(`/districts/${v}`);
                    setDistricts(res.data.data || []);
                  }
                }}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>เขต/อำเภอ</label>
              <SearchableSelect
                value={selDistrictId}
                options={districts.map((d) => ({ value: d.DistrictId, label: d.NameInThai }))}
                placeholder="เลือกอำเภอ"
                searchPlaceholder="ค้นหาอำเภอ..."
                disabled={!districts.length}
                onChange={async (v, opt) => {
                  setSelDistrictId(v);
                  setFormData((prev) => ({ ...prev, AP_Add3: opt?.label || "", AP_Add2: "", AP_Zipcode: "" }));
                  setSubdistricts([]);
                  setSelSubdistrictId("");
                  if (v) {
                    const res = await api.get(`/subdistricts/${v}`);
                    setSubdistricts(res.data.data || []);
                  }
                }}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>แขวง/ตำบล</label>
              <SearchableSelect
                value={selSubdistrictId}
                options={subdistricts.map((s) => ({ value: s.SubdistrictId, label: s.NameInThai }))}
                placeholder="เลือกตำบล"
                searchPlaceholder="ค้นหาตำบล..."
                disabled={!subdistricts.length}
                onChange={(v, opt) => {
                  const selected = subdistricts.find((s) => String(s.SubdistrictId) === String(v));
                  setSelSubdistrictId(v);
                  setFormData((prev) => ({ ...prev, AP_Add2: opt?.label || (selected ? selected.NameInThai : ""), AP_Zipcode: selected ? selected.ZipCode : prev.AP_Zipcode }));
                }}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <label style={labelStyle}>รหัสไปรษณีย์</label>
              <input type="text" name="AP_Zipcode" className="form-control" value={formData.AP_Zipcode || ""} onChange={handleChange} style={inputStyle} />
            </div>
          </div>
        </div>
        {isCreditor && (
          <div className="mb-4">
              <div style={sectionHeaderStyle}>
                <i className="fas fa-university" style={sectionIconStyle}></i>
                <h5 style={sectionTitleStyle}>บัญชีธนาคารผู้ขาย</h5>
              </div>

              <div className="table-responsive">
                <table className="table table-sm table-bordered">
                  <thead style={{ background: '#E13F57', color: '#fff' }}>
                    <tr>
                      <th className="text-center" style={{ width: '30%', color: '#fff' }}>เลขที่บัญชี</th>
                      <th className="text-center" style={{ width: '40%', color: '#fff' }}>ชื่อบัญชี</th>
                      <th className="text-center" style={{ width: '10%', color: '#fff' }}>ประเภท</th>
                      <th className="text-center" style={{ width: '20%', color: '#fff' }}>จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bankList && bankList.length ? (
                      bankList.map((b) => (
                        <tr key={b.Bank_Id}>
                          <td className="text-center">{b.Bank_Account || '-'}</td>
                          <td className="text-left">{b.Bank_Name_TH || '-'}</td>
                          <td className="text-center">{b.Bank_Type === 'SA' ? 'เจ้าหนี้' : b.Bank_Type === 'CA' ? 'กระแสรายวัน' : (b.Bank_Type || '-')}</td>
                          <td className="text-center">
                            <button type="button" className="btn btn-sm btn-outline-secondary me-2" onClick={() => startEditBank(b)}>แก้ไข</button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeBank(b.Bank_Id)}>ลบ</button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center text-muted">ไม่มีข้อมูลบัญชี</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="mt-3">
                {bankEditing ? (
                  <div className="row g-2 align-items-end">
                    <div className="col-md-4">
                      <label className="form-label">เลขที่บัญชี</label>
                      <input type="text" name="Bank_Account" className="form-control" value={bankForm.Bank_Account} onChange={handleBankChange} placeholder="xxx-xxx-xxxx" maxLength={12} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">ชื่อบัญชี</label>
                      <input type="text" name="Bank_Name_TH" className="form-control" value={bankForm.Bank_Name_TH} onChange={handleBankChange} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">ประเภท</label>
                      <select name="Bank_Type" className="form-select" value={bankForm.Bank_Type} onChange={handleBankChange}>
                        <option value="SA">ออมทรัพย์</option>
                        <option value="CA">กระแสรายวัน</option>
                      </select>
                    </div>
                    <div className="col-md-2 d-flex gap-2">
                      <button type="button" className="btn btn-success" onClick={saveBank}>บันทึก</button>
                      <button type="button" className="btn btn-secondary" onClick={cancelBankEdit}>ยกเลิก</button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <button type="button" className="btn" onClick={startAddBank} style={{ background: '#E13F57', color: '#fff', borderColor: '#E13F57' }}>+ เพิ่มบัญชีธนาคาร</button>
                  </div>
                )}
              </div>
          </div>
        )}
      </InitialDataFormLayout>
    </>
  );
};

export default CreditorForm;
